import { ValidationResult } from "./validation-result";

export interface RequestStatus {
	id: number;
	shortDescription: string;
	description: string;
	recordStatus: number;
	activeStatus: string;
	selectable: number
	reassignAgencyId: number;
	enableReassignment: number;
	enableCustomActions: number;
	isSelected: boolean;
}

export class RequestStatus {
	constructor() {
		this.id = 0;
		this.shortDescription = '';
		this.description = '';
		this.recordStatus = 0;
		this.activeStatus = '';
		this.selectable = 0;
		this.enableReassignment = 0;
		this.reassignAgencyId=0;
	}
	validateRecord(): ValidationResult {
		const vr: ValidationResult = new ValidationResult();


		if (this.shortDescription.length < 5) {
			vr.focus_field = 'shortDescription';
			vr.error = 'Error: A label is required (must be more than 5 characters)';
			return vr;
		}
		if (this.description.length < 5) {
			vr.focus_field = 'description';
			vr.error = 'Error: A label is required (must be more than 5 characters)';
			return vr;
		}

		if (this.recordStatus === null) {
			vr.focus_field = 'recordStatus';
			vr.error = 'Error: A Finalization code is required';
			return vr;
		}
		return vr;
	}
}
